// extracted by mini-css-extract-plugin
module.exports = {"bi-chevron-down":"MailchimpForSuppliers_bi-chevron-down__gMl8r","supplierForm":"MailchimpForSuppliers_supplierForm__2FvEf"};